const init = () => {
	const forms = Array.from(document.querySelectorAll('.wpcf7-form'));
	const rows = Array.from(document.querySelectorAll('.wpcf7-form .form-row'));

	forms.forEach((form) => {
		const submitBtn = form.querySelector('.wpcf7-submit');
		const output = form.querySelector('.wpcf7-response-output');

		submitBtn.addEventListener('click', () => {
			output.scrollIntoView({
				behavior: 'smooth',
				block: 'start',
				inline: 'nearest',
			});
		});
	});

	rows.forEach((row) => {
		const label = row.querySelector('label');
		const input = row.querySelector(
			"input:not([type='checkbox'], [type='radio'], [type='submit'])"
		);

		if (!label || !input) return;

		input.addEventListener('focusin', () => {
			label.classList.add('contract');
		});

		input.addEventListener('blur', () => {
			if (input.value.trim() === '') label.classList.remove('contract');
		});
	});
};

if (document.readyState !== 'loading') {
	init();
} else {
	document.addEventListener('DOMContentLoaded', () => {
		init();
	});
}
